import { forwardRef } from "react";
import type { HydratedImage } from "../generated/api/types.gen";
import type { DownloadScale } from "../lib/image-download";
import { Button } from "./Button";
import { DownloadDropdown } from "./DownloadDropdown";

interface GalleryImageViewerProps {
  image: HydratedImage;
  currentIndex: number;
  totalCount: number;
  onResumeFromHere: () => void;
  onDownload: (scale: DownloadScale) => void;
  isDownloading: boolean;
}

export const GalleryImageViewer = forwardRef<
  HTMLDivElement,
  GalleryImageViewerProps
>(function GalleryImageViewer(
  {
    image,
    currentIndex,
    totalCount,
    onResumeFromHere,
    onDownload,
    isDownloading,
  },
  ref,
) {
  return (
    <div className="flex flex-col items-start justify-center min-h-0 w-fit max-w-full overflow-hidden">
      <div ref={ref} className="relative inline-flex max-w-full max-h-full">
        <img
          src={image.url}
          alt={image.design_subject || "Design"}
          className="max-w-full max-h-full object-contain rounded-xl border border-[var(--stroke-field)]"
        />

        {/* Image Counter Badge */}
        <div className="absolute bottom-4 left-4 bg-[var(--bg-modal)]/90 text-[var(--text-primary)] px-3 py-1.5 rounded-lg text-sm font-medium">
          {currentIndex + 1}/{totalCount}
        </div>

        {/* Action Buttons */}
        <div className="absolute bottom-4 right-4 flex gap-3">
          <Button
            onClick={onResumeFromHere}
            variant="secondary"
            className="!text-black"
          >
            Resume from Here
          </Button>
          <DownloadDropdown
            onSelect={onDownload}
            isDownloading={isDownloading}
          />
        </div>
      </div>
    </div>
  );
});
